import styles from './EndAdornment.module.scss';

export const EndAdornment = (props: { children: React.ReactNode }) => {
  return <div className={styles.adornment}>{props.children}</div>;
};
